import { Box, Typography } from '@mui/material';

import { formatRichText } from './format-rich-text';

type BulletListProps = {
  items: string[];
};

export const BulletList = ({ items }: BulletListProps) => (
  <Box>
    {items.map((item) => (
      <Typography
        key={item}
        variant="body2"
        className="secondary"
        sx={{
          lineHeight: '24px',
        }}
      >
        • {formatRichText(item)}
      </Typography>
    ))}
  </Box>
);
